var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.756,
    height: 20,
    viewBox: "0 0 16.756 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Focus-Mark",
    transform: "translate(8.378 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Focus-Mark-2",
    "data-name": "Focus-Mark",
    transform: "translate(-8.378 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Focus_Dot",
    "data-name": "Focus Dot",
    d: "M1.852,150H1.5A1.5,1.5,0,0,0,0,151.5v.338a1.5,1.5,0,0,0,1.5,1.5h.338a1.5,1.5,0,0,0,1.5-1.5v-.367A1.468,1.468,0,0,0,1.865,150",
    transform: "translate(0 -133.333)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "F-Skid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(0 8.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lower_Skid",
    "data-name": "Lower Skid",
    d: "M9.305,76.963v-.538A1.805,1.805,0,0,1,10,75H1.586A1.586,1.586,0,0,0,0,76.588v.162a1.586,1.586,0,0,0,1.586,1.586H10a1.806,1.806,0,0,1-.695-1.423",
    transform: "translate(0 -75.002)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lower_Focus_Accent_Dot",
    "data-name": "Lower Focus Accent Dot",
    d: "M92.767,75h-.526a1.435,1.435,0,0,0-1.435,1.435V76.9a1.435,1.435,0,0,0,1.435,1.435H92.7A1.435,1.435,0,0,0,94.139,76.9v-.43A1.468,1.468,0,0,0,92.671,75",
    transform: "translate(-80.716 -75.002)",
    fill: "#45a041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Upper_Skid",
    "data-name": "Upper Skid",
    d: "M12.639,1.961V1.423A1.8,1.8,0,0,1,13.333,0H1.586A1.586,1.586,0,0,0,0,1.586v.162A1.586,1.586,0,0,0,1.586,3.333H13.333a1.805,1.805,0,0,1-.695-1.423",
    transform: "translate(0)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Upper_Focus_Accent_Dot",
    "data-name": "Upper Focus Accent Dot",
    d: "M122.766,0h-.526a1.435,1.435,0,0,0-1.435,1.435V1.9a1.435,1.435,0,0,0,1.435,1.435h.464A1.435,1.435,0,0,0,124.138,1.9v-.43A1.468,1.468,0,0,0,122.67,0",
    transform: "translate(-107.382)",
    fill: "#45a041"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusIcon);
export default __webpack_public_path__ + "static/media/Focus-Icon.2178abf451fed52c23c31b6d774c50a5.svg";
export { ForwardRef as ReactComponent };